import React from "react";
import styled from "styled-components";
import {VirtualizedTable} from "../../../elements/VirtualizedTable";
import {shadedBackgroundColour} from "../../../../style/styleConsts";

const padding = 12;

const PortfolioListContainer = styled.div`
    display: flex;
    flex-grow: 1;
    flex-direction: column;
    min-width: 384px;
    border: solid 1px #e1dbd5;
    box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.16);
    padding-top: ${padding + "px"};
    padding-right: ${padding + "px"};
    padding-left: ${padding + "px"};
    overflow: hidden;
`;

const HeaderBar = styled.div`
    color: #4a4a4a;
    font-weight: bold;
    text-align: center;
    background-color: ${shadedBackgroundColour};
    padding: ${padding + "px"};
    margin: ${-padding + "px"} ${-padding + "px"} ${padding + "px"};
    border-bottom: solid 1px #e1dbd5;
`;

const HeaderRow = styled.div`
    display: flex;
    align-items: center;
    flex-shrink: 0;
    border-bottom: 3px solid #3b7433;
    padding-left: 6px;
    padding-right: 6px;
    padding-bottom: 6px;
`;

const PortfolioList = ({portfolios, headerElements, portfolioRenderer}) => {
    const allOpenPortfolios = portfolios;

    const rowRenderer = ({rowData, style}) => {
        return portfolioRenderer(rowData, style);
    };
    return (

        <PortfolioListContainer className="t-portfolios">
            <HeaderBar>
                Current Reward Period
            </HeaderBar>
            <HeaderRow>
                {headerElements}
            </HeaderRow>

            <VirtualizedTable disableHeader={true}
                              rowHeight={42}
                              rowRenderer={rowRenderer}
                              rowCount={allOpenPortfolios.length}
                              rowGetter={({index}) => allOpenPortfolios[index]}/>
        </PortfolioListContainer>
    );
};

export default PortfolioList;